/**
 * Campo de información de solo lectura: icono en caja, label en mayúsculas y contenido.
 * compact: versión reducida para listas móviles. highlight: caja en rojo corporativo.
 */
import React from "react";
import { Box, Typography } from "@mui/material";

const InfoField = ({ icon: Icon, label, children, highlight = false, compact = false, fullWidth = false }) => (
    <Box
        sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: compact ? 1 : 1.5,
            width: fullWidth ? "100%" : "auto"
        }}
    >
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: compact ? 28 : 32,
                height: compact ? 28 : 32,
                borderRadius: 1,
                backgroundColor: highlight ? "#cc071e" : "#f8f9fa",
                flexShrink: 0,
                mt: 0.25
            }}
        >
            <Icon sx={{ fontSize: compact ? 16 : 18, color: highlight ? "#fff" : "#6c757d" }} />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
                sx={{
                    fontSize: compact ? 10 : 11,
                    fontWeight: 600,
                    color: "#6c757d",
                    textTransform: "uppercase",
                    letterSpacing: compact ? "0.3px" : "0.5px",
                    mb: compact ? 0.25 : 0.5
                }}
            >
                {label}
            </Typography>
            {children}
        </Box>
    </Box>
);

export default InfoField;
